import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import api from "@/lib/api";

/** A public GET remains loading throughout the central retry sequence. */
export function usePublicData(url) {
  const [state, setState] = useState({ data: null, loading: Boolean(url), error: null });
  const [revision, setRevision] = useState(0);
  const retry = useCallback(() => {
    setState({ data: null, loading: true, error: null });
    setRevision((value) => value + 1);
  }, []);
  useEffect(() => {
    if (!url) {
      setState({ data: null, loading: false, error: null });
      return;
    }
    const controller = new AbortController();
    setState({ data: null, loading: true, error: null });
    api.get(url, { signal: controller.signal })
      .then(({ data }) => {
        if (!controller.signal.aborted) setState({ data, loading: false, error: null });
      })
      .catch((error) => {
        if (!axios.isCancel(error) && !controller.signal.aborted) setState({ data: null, loading: false, error });
      });
    return () => controller.abort();
  }, [url, revision]);
  return { ...state, retry };
}
